import {
    debug, form, formHelpers, Formsy, i18n, inject, observable, observer, pr, React, RouteComponentProps, theme, ui
} from "aaa";
import { Employment, EMPLOYMENT_TYPES, MARITAL_STATUS, RESIDENCE_STATUS, User } from "models/User";
import * as helpers from "util/helpers";
import { AnimDiv } from "@aaa/animdiv";


type IEmploymentProps = i18n.InjectedIntlProps & {
    employment: Employment,
    prefix: string
};

@i18n.injectIntl
@observer
export class EmploymentComponent extends React.Component<IEmploymentProps, {}> {
    @observable
    private employmentOtherDetailVisible = false;

    @observable
    private employmentFieldsVisible = false;

    constructor(props: IEmploymentProps) {
        super(props);
        this.employmentFieldsVisible = Boolean(props.employment.employment)
            && props.employment.employmentKey !== "employment.retired"
            && props.employment.employmentKey !== "employment.private"
            && props.employment.employmentKey !== "employment.other";

        this.employmentOtherDetailVisible = Boolean(props.employment.employmentDetail);

        debug.log("### employmentOtherDetailVisile", this.employmentOtherDetailVisible, props.employment.employmentDetail, props.employment.employmentKey);
    }

    onEmploymentChanged = (key: string) => {
        this.employmentOtherDetailVisible = key === "employment.other";
        this.employmentFieldsVisible = key !== "employment.retired" && key !== "employment.private" && key !== "employment.other";
    }

    render() {
        return (
            <div>
                <form.FormsySelect
                    name={this.props.prefix + "employment"}
                    required={true}
                    fullWidth={true}
                    floatingLabelText={ui.__("employment")}
                    validationError={ui.__("error.requiredField")}
                    onChange={(event: any, value: number) => this.onEmploymentChanged(EMPLOYMENT_TYPES[value])}
                    value={helpers.indexOfStringInKeyArray(this.props.employment.employment, EMPLOYMENT_TYPES)}
                >
                    {formHelpers.stringsToMenuItems(EMPLOYMENT_TYPES)}
                </form.FormsySelect>

                <AnimDiv key={this.employmentFieldsVisible ? 0 : 1} >

                    {this.employmentOtherDetailVisible && <form.FormsyText
                        name={this.props.prefix + "employmentDetail"}
                        validations="minLength:1"
                        required
                        fullWidth={true}
                        floatingLabelText={ui.__("employment.detail")}
                        validationError={ui.__("error.requiredField")}
                        value={this.props.employment.employmentDetail}
                    />}

                    {this.employmentFieldsVisible &&
                        <div>
                            <form.FormsyText
                                name={this.props.prefix + "job"}
                                required={true}
                                validations="minLength:1"
                                floatingLabelText={ui.__("job")}
                                fullWidth={true}
                                validationError={ui.__("error.requiredField")}
                                value={this.props.employment.job}
                            />

                            <form.FormsyText
                                name={this.props.prefix + "employer"}
                                required={true}
                                validations="minLength:1"
                                floatingLabelText={ui.__("employer")}
                                fullWidth={true}
                                validationError={ui.__("error.requiredField")}
                                value={this.props.employment.employer}
                            />

                            <form.FormsyText
                                name={this.props.prefix + "employedSince"}
                                required={true}
                                validations="isDateDDMMYYYY"
                                floatingLabelText={ui.__("employedSince")}
                                floatingLabelStyle={{ marginTop: ui.isMobile ? -20 : 0 }}
                                fullWidth={true}
                                validationError={ui.__("error.dateInvalid")}
                                value={this.props.employment.employedSince}
                            />
                        </div>
                    }
                </AnimDiv>
            </div>
        );
    }
}


type IProps = i18n.InjectedIntlProps & {
    user: User,
    isSummary?: boolean
};


@i18n.injectIntl
@inject("user")
@observer
export class PersonalDataContent extends React.Component<IProps, {}> {

    render() {
        return (
            <div>
                <form.FormsySelect
                    name="maritalStatus"
                    required={true}
                    fullWidth={true}
                    floatingLabelText={ui.__("maritalStatus")}
                    validationError={ui.__("error.requiredField")}
                    value={helpers.indexOfStringInKeyArray(this.props.user.maritalStatus, MARITAL_STATUS)}
                >
                    {formHelpers.stringsToMenuItems(MARITAL_STATUS)}
                </form.FormsySelect>

                <formHelpers.UserTextField
                    user={this.props.user}
                    fieldName="peopleInHousehold"
                    validations="isInt"
                    validationErrorID="error.formatInvalid"
                />

                <form.FormsySelect
                    name="residenceStatus"
                    required={true}
                    fullWidth={true}
                    floatingLabelText={ui.__("residenceStatus")}
                    validationError={ui.__("error.requiredField")}
                    value={helpers.indexOfStringInKeyArray(this.props.user.residenceStatus, RESIDENCE_STATUS)}
                >
                    {formHelpers.stringsToMenuItems(RESIDENCE_STATUS)}
                </form.FormsySelect>

                <form.FormsyText
                    name="residenceSince"
                    required={true}
                    validations="isDateDDMMYYYY"
                    floatingLabelText={ui.__("residenceSince", {
                        address: this.props.user.address + ", " + this.props.user.zipCode + " " + this.props.user.residence
                    })}
                    floatingLabelStyle={{ marginTop: ui.isMobile ? -20 : 0 }}
                    fullWidth={true}
                    validationError={ui.__("error.dateInvalid")}
                    value={this.props.user.residenceSince}
                />

                <form.FormsyText
                    name="citizenship"
                    required={true}
                    validations="minLength:1"
                    floatingLabelText={ui.__("citizenship")}
                    fullWidth={true}
                    value={this.props.user.citizenship ? this.props.user.citizenship : ui.__("germany")}
                    validationError={ui.__("error.requiredField")}
                />

                <EmploymentComponent
                    prefix=""
                    employment={this.props.user.employment}
                />

                {
                    this.props.user.hasSecondBorrower &&
                    this.props.isSummary !== true &&
                    < div >
                        <pr.Title style={{ marginTop: theme.MARGIN }}>
                            {ui.__("secondBorrowerEmployment") + " " + (this.props.user.secondBorrowerName || ui.__("secondBorrower"))}
                        </pr.Title>
                        <EmploymentComponent
                            prefix="second_"
                            employment={this.props.user.secondBorrowerEmployment}
                        />
                    </div>}
            </div>
        );
    }
}


@i18n.injectIntl
@inject("user")
@observer
export class PersonalDataForm extends React.Component<RouteComponentProps<{}> & IProps, {}> {

    @observable
    formIsValid = false;

    private formRef: any;

    static parseInput(user: User, fields: any) {
        user.maritalStatus = ui.__(MARITAL_STATUS[fields.maritalStatus] as i18n.IDS);
        user.peopleInHousehold = fields.peopleInHousehold;
        user.residenceStatus = ui.__(RESIDENCE_STATUS[fields.residenceStatus] as i18n.IDS);
        user.residenceSince = fields.residenceSince;
        user.citizenship = fields.citizenship;

        user.employment.employment = ui.__(EMPLOYMENT_TYPES[fields.employment] as i18n.IDS);
        user.employment.employmentDetail = fields.employmentDetail;
        user.employment.job = fields.job;
        user.employment.employer = fields.employer;
        user.employment.employedSince = fields.employedSince;

        if (user.hasSecondBorrower) {
            user.secondBorrowerEmployment.employment = ui.__(EMPLOYMENT_TYPES[fields.second_employment] as i18n.IDS);
            user.secondBorrowerEmployment.employmentDetail = fields.second_employmentDetail;
            user.secondBorrowerEmployment.job = fields.second_job;
            user.secondBorrowerEmployment.employer = fields.second_employer;
            user.secondBorrowerEmployment.employedSince = fields.second_employedSince;
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    onSubmit = (fields: any, resetForm: any, invalidateForm: any) => {
        const user = this.props.user;
        PersonalDataForm.parseInput(user, fields);
        debug.log("### PersonalDataForm", user);

        this.props.history.push("/contact");
    }

    render() {
        return (
            <pr.FormContainer>
                <Formsy.Form
                    onInvalidSubmit={(fields: any, reset: any, invalidate: any) => formHelpers.invalidateRequiredFields(this.formRef, invalidate)}
                    onValidSubmit={this.onSubmit}
                    onValid={() => { this.formIsValid = true; }}
                    onInvalid={() => { this.formIsValid = false; }}
                    noValidate
                    ref={(c: any) => this.formRef = c}
                >
                    <PersonalDataContent user={this.props.user} />
                    {formHelpers.renderActionButton(ui.__("continue"))}
                </Formsy.Form>
            </pr.FormContainer>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/PersonalDataForm.tsx